import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from '../styles.scss';

const QaPair = (props) => {
	const { caret, isMobile, idx, item, setCaret } = props;

	return (
		<div className={Styles.data} key={item.question}>
			<div
				className={Styles.iconSplit}
				onClick={(e) => {
					e.preventDefault();
					if (isMobile) {
						const newCaret = [...caret];
						newCaret[idx].name =
							newCaret[idx].name === 'caret-up' ? 'caret-down' : 'caret-up';
						newCaret[idx].isOpen = !newCaret[idx].isOpen;
						setCaret(newCaret);
					}
				}}
			>
				{caret[idx] && (
					<Icon
						className={Styles.icon}
						name={caret[idx].name}
						size="md"
						data-testid={`caret_${idx}_${caret[idx].name}`}
					/>
				)}
				<TextBody size="md" bold className={Styles.question}>
					{`Q: ${item.question}`}
				</TextBody>
			</div>
			{!isMobile && (
				<TextBody size="md" className={Styles.answer}>
					{`A: ${item.answer}`}
				</TextBody>
			)}
			{isMobile && caret[idx] && caret[idx].isOpen && (
				<TextBody size="md" className={Styles.answer}>
					{`A: ${item.answer}`}
				</TextBody>
			)}
		</div>
	);
};

QaPair.propTypes = {
	caret: PropTypes.arrayOf(PropTypes.object).isRequired,
	idx: PropTypes.number.isRequired,
	isMobile: PropTypes.bool.isRequired,
	item: PropTypes.shape({
		question: PropTypes.string,
		answer: PropTypes.string,
	}).isRequired,
	setCaret: PropTypes.func.isRequired,
};

export default QaPair;
